<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">IMPORTAR MAXISACOS</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>
                <modal-ayuda></modal-ayuda>
            </v-card-text>
        </v-card>

        <v-row>
            <v-tabs
            background-color="blue accent-3"
            class="elevation-2"
            dark
            :centered="true"
            :grow="true"
            :vertical="false"
            :right="false"
            prev-icon="mdi-arrow-left-bold-box-outline"
            next-icon="mdi-arrow-right-bold-box-outline"
            :icons-and-text="true"
            >
            <v-tabs-slider></v-tabs-slider>

            <!-- tab generar formato -->
            <v-tab
                :href="`#tab-generar-excel`"
            >
                Descargar Formato
                <v-icon>get_app</v-icon>
            </v-tab>

            <v-tab-item
                :value="'tab-generar-excel'"
            >
                <v-card
                flat
                tile
                >
                <v-card-text>Descargar Formato Excel</v-card-text>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-select
                            outlined
                            v-model="select_generar_formato"
                            :items="bodegas"
                            item-text="nombre"
                            item-value="id"
                            label="Seleccione Bodega"
                            ></v-select>
                        </v-col>
                        <v-col>
                            <v-btn color="blue" dark @click="generarFormato"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    
                </v-card-text>
                </v-card>
            </v-tab-item>
            <!-- tab generar formato -->

            <!-- tab importar Excel -->
            <v-tab
                :href="`#tab-importar-excel`"
            >
                Importar Datos
                <v-icon>publish</v-icon>
            </v-tab>

            <v-tab-item
                :value="'tab-importar-excel'"
            >
                <v-card
                flat
                tile
                >
                <v-card-text>Importar Excel</v-card-text>
                <v-card-text>
                    <alert></alert>

                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                    >
                        <v-row>
                            <v-col cols="6" sm="2">
                                <v-select
                                outlined
                                dense
                                v-model="select_bodega_origen"
                                :items="bodegas"
                                item-text="nombre"
                                item-value="id"
                                label="Seleccione Bodega Origen"
                                ></v-select>
                            </v-col>
                            <v-col cols="6" sm="2">
                                <v-select
                                outlined
                                dense
                                v-model="select_bodega_destino"
                                :items="bodegas"
                                item-text="nombre"
                                item-value="id"
                                label="Seleccione Bodega Destino"
                                ></v-select>
                            </v-col>
                            <v-col cols="6" sm="2">
                                <date-picker class="dtpicker" v-model="fecha" format="DD-MM-YYYY" label="Fecha Movimiento" valueType="YYYY-MM-DD"></date-picker>
                            </v-col>
                            <v-col cols="6" sm="2">
                                <v-select
                                    v-model="select_tipos"
                                    :items="tipos"
                                    item-text="tipo"
                                    item-value="id"
                                    label="Tipo Movimiento"
                                    color="blue darken-3"
                                    persistent-hint
                                    @change="cargarDocumentos"
                                    >
                                </v-select>
                            </v-col>
                            <v-col cols="6" sm="2">
                                <v-select
                                    v-model="select_motivos"
                                    :items="motivos"
                                    item-text="texto"
                                    item-value="valor"
                                    label="Motivo Movimiento"
                                    color="blue darken-3"
                                    persistent-hint
                                    @change="cargarDocumentos"
                                    >
                                </v-select>
                            </v-col>
                            <v-col cols="6" sm="2" class="align-end">
                                <v-text-field
                                    dense
                                    v-model="guias"
                                    label="Nro Guía"
                                    :rules="validar_guia"
                                    @change="validarGuia()"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>

                <!-- DOCUMENTOS DINAMICOS -->
                    <v-simple-table dense>
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">
                            Documento
                        </th>
                        <th class="text-left">
                            Agregue Dato
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                        v-for="(item,idx) in datos_adicionales"
                        :key="item.id"
                        >
                        <td>{{ item.documento }}</td>
                        <td>
                            <input class="inputcito" type="text" name="" id="" v-if="item.tipo_dato == 'Texto'" v-model="item.valor_dato">
                            <input class="inputcito" type="number" name="" id="" v-if="item.tipo_dato == 'Numero'" v-model="item.valor_dato">
                            <input class="inputcito" type="file" name="" id="" v-if="item.tipo_dato == 'Archivo'" @change="subir_archivo($event,idx)">
                            <input class="inputcito" type="date" v-if="item.tipo_dato == 'Fecha'" v-model="item.valor_dato">
                        </td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
                <!-- DOCUMENTOS DINAMICOS -->

                    <v-row>
                        <v-col>
                            <v-file-input
                            id="input_archivo"
                            @change="cambioArchivo"
                            v-model="archivo" 
                            label="Agregue Excel" 
                            accept=".xlsx, .xls"
                            outlined 
                            dense>
                            </v-file-input>
                        </v-col>
                        <v-col>
                            <v-btn color="green darken-1"  :dark="!desactivar_importar" :disabled="desactivar_importar" @click="importarDatos"><v-icon>publish</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                </v-card>
            </v-tab-item>
            <!-- tab importar Excel -->

    </v-tabs>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Alert from '@/components/shared/Alert.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        bodegas:[],
        tipos:[{id:'I', tipo:'Ingreso'}, {id:'S',tipo:'Salida'}],
        //motivos:[{id:1, motivo:'Traslado'}, {id:2, motivo:'Despacho'}, {id:3, motivo:'Reproceso'}, {id:4, motivo:'Repaso'}],
        motivos:[],
        guias:'',
        fecha: new Date().toISOString().substr(0, 10),
        mostrar_fecha: false,
        select_generar_formato:'',
        select_bodega_origen:'',
        select_bodega_destino:'',
        select_tipos :'',
        select_motivos:'',
        archivo:{},
        formatos_aceptados:['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/wps-office.xlsx'],
        documentos:[],
        datos_adicionales:[],
        valid: true,
        validar_guia: [v => true],
    }),
    mounted() {
        this.cargarBodegas();
    },
    methods: {
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Importar Maxisacos`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:` Desde esta pantalla se ingresan al sistema, mediante archivo Excel, maxisacos que vienen desde las bodegas para reprocesarlos. `},
                        {   tipo:`label`,   texto:`- Al hacer click en "Descargar Formato", se puede tener el formato que utiliza el sistema para importar los maxisacos (Seleccione una Bodega de Origen y luego haga click al botón Descargar)`},
                        {   tipo:`label`,   texto:`- En "Importar Datos" se completan los datos necesarios (Bodega Origen, Bodega Destino = Planta La Portada, Fecha, Tipo Movimiento = Ingreso , Motivo Movimiento = Reproceso y Nro de Guía), luego se selecciona el Excel con la información de los maxisacos a ingresar y se le da clic al botón para importar para cargar el excel al sistema`},
                        {   tipo:`imgtexto`,  url:`importa-maxis-guia.png`, ratio:'2.7', cols:'1',   texto:`Si una guía ya está ingresada, se mostrará una validación indicando en que movimiento está ingresada `},
                        {   tipo:`imgtexto`,  url:`help-importar-reprocesos.png`, ratio:'4.3', cols:'2',   texto:`El formato de importación contiene estas columnas... \n El sistema comienza a leer desde la fila número 3 `},
                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async validarGuia(){
            this.validar_guia = [v => true]
            if (this.guias){
                if (this.guias.trim() !== '') {
                    await this.axios.get(`${this.base_url}movimiento/buscar_guia/${this.guias}`,this.headers).then((res)=>{
                        if (res.data.data.existe == true) {
                            this.validar_guia = [v => 'Guía ya está ingresada en movimiento ' + res.data.data.movimiento ]
                        }
                    }).catch((e)=>{
                        console.log(e);
                        this.validar_guia = [v => 'Error al buscar la Guía' ]
                    });
                }
            }
            console.log(this.validar_guia)
            this.$refs.form.validate()
        },
        async cargarBodegas(){
            //this.mostrarLoading('Cargando Bodegas...');
            this.mostrarLoading({titulo:'Cargando Bodegas...',color:'green'})

            let url = `${this.base_url}get_bodegas`;
            // console.log('headers',this.headers.headers);
            this.axios.get(url,this.headers).then((res)=>{
                this.bodegas = res.data.data;
                console.log('bodegas',this.bodegas);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
            this.cargarMotivos();
        },

        async cargarDocumentos(){
            this.documentos = [];
            this.datos_adicionales=[];
            await this.axios.get(`${this.base_url}mov_documentos?tipo_movimiento=${this.select_tipos}&motivo_movimiento=${this.select_motivos}&tipo_produccion_id=1&limit=99999999`,this.headers).then((res)=>{
                this.documentos = res.data.data.data;
                this.documentos.forEach(d => {
                    this.datos_adicionales.push({
                        mov_documentos_id:d.id,
                        valor_dato:'',
                        tipo_dato:d.tipo_dato_texto,
                        documento:d.documento
                    });
                    //this.$set(this.documentos[idx],'valor','');
                });
            }).catch((e)=>{
                console.log(e);
            });
        },

        async cargarMotivos(){
            await this.axios.get(`${this.base_url}movimiento/motivos`,this.headers).then((res)=>{
                this.motivos = res.data.data;
            }).catch((e)=>{
                console.log(e);
            });
        },

        cambioArchivo(){
            console.log('archivo',this.archivo);
            // busca entre los formatos aceptados
            var aceptado = this.formatos_aceptados.find(formato => {
                return formato === this.archivo.type;
            });
            
            if(aceptado == undefined){
                /**solo se acepta archivos excel */
                this.archivo = {};
            }
            console.log('aceptado',aceptado);
        },

        async generarFormato(){
            console.log('Bodega',this.select_generar_formato);
            let url = `${this.base_url}movimientos/formato_importacion/${this.select_generar_formato}`;
            this.axios.get(url,this.headers).then((res)=>{
                console.log('respuesta formato',res);
                window.location.href = res.data.data;
            }).catch((error)=>{
                console.log('error',error);
            });
        },

        async subir_archivo($event,idx){

            let archivo = $event.target.files[0];
            this.mostrarLoading({titulo:'Subiendo Archivo...',color:'green'})

            //subiendo el archivo
            let token = this.headers.headers['Authorization'];
            let cabecera = {
                headers:{
                    'Authorization':token,
                    'Content-Type':'multipart/form-data'
                }
            }

            let body = new FormData();
            body.append('archivo', archivo);
            
            let url = `${this.base_url}movimientos/subir_documento`;
            console.log('headers',cabecera);
            await this.axios.post(url, body, cabecera).then((res) =>{
                //this.enviarNombreArchivo(res);
                this.$set(this.datos_adicionales[idx],'valor_dato',res.data.nombre_archivo);
            }).catch((error) =>{
                console.log('error',error);
                
            });
            this.ocultarLoading();
            //console.log($event,idx);
        },

        async importarDatos(){
            //this.mostrarLoading('Subiendo Archivo...');
            this.mostrarLoading({titulo:'Subiendo Archivo...',color:'green'})
            this.$refs.form.resetValidation()

            //subiendo el archivo
            let token = this.headers.headers['Authorization'];
            let cabecera = {
                headers:{
                    'Authorization':token,
                    'Content-Type':'multipart/form-data'
                }
            }
            // cabecera['headers']['Content-Type']='multipart/form-data';

            let body = new FormData();
            body.append('archivo', this.archivo);
            
            let url = `${this.base_url}movimientos/subir_archivo`;
            console.log('headers',cabecera);
            await this.axios.post(url, body, cabecera).then((res) =>{
                this.enviarNombreArchivo(res);
            }).catch((error) =>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async enviarNombreArchivo(res){
            console.log('cabecera',this.headers);
            console.log('res archivo',res);
            //this.mostrarLoading('Procesando Datos...');
            this.mostrarLoading({titulo:'Procesando Datos...',color:'green'})

            let url = `${this.base_url}movimientos/importar_maxisacos/${this.select_bodega_origen}`;
            let body = {
                nombre_archivo:res.data.nombre,
                fecha:this.fecha,
                tipo:this.select_tipos,
                motivo:this.select_motivos,
                bodega_origen:this.select_bodega_origen,
                bodega_destino:1,
                guias:this.guias,
                mov_informacion:this.datos_adicionales,
                bodega_destino:this.select_bodega_destino
            }
            let conf = {};
            console.log("fecha: " + this.fecha);
            //enviando nombre de archivo
            await this.axios.post(url,body,this.headers).then((res)=>{
                console.log('archivo importado',res.data.message);
                conf.tipo = "success";
                conf.mensaje = res.data.message;
                Event.$emit('mostrar_alert',conf);
                this.limpiar();
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                conf.tipo = "error";
                conf.mensaje = `No se Ha podido importar el archivo`;
                Event.$emit('mostrar_alert',conf);
                this.ocultarLoading();
            });
        },
        limpiar(){
            this.select_bodega_origen='',
            this.fecha='',
            //this.select_bodega_destino='',
            this.select_motivos='',
            this.archivo = {};
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        desactivar_importar(){
            if(this.archivo != {} && this.select_bodega_origen != ''){
                var aceptado = this.formatos_aceptados.find(formato => {
                return formato === this.archivo.type;
                });
                if(aceptado == undefined){
                    return true;
                }else{
                    return false;
                }
            }

            return true;
        },
        ...mapState(['base_url','headers']),
    },
    components:{
        'alert':Alert,
        DatePicker,
        'modal-ayuda':ModalAyudas
    }
}
</script>

<style scoped>
    .mx-datepicker{
        width: 100% !important;
    }
    .inputcito{
        border:1px solid #ccc;
        margin:0.5em 0.5em;
    }
</style>